import React from "react";

import Card from "../Card";

import { educationTitle, educationData } from "../../data/educationData";

import { sortByImportance } from "../../utils";

const Education = ({ activeSection }) => {
  const educations = sortByImportance(educationData);

  return (
    <section id="education">
      <h3 className={activeSection === "education" ? "active" : ""}>
        {educationTitle}
      </h3>
      <ul>
        {educations.map((el) => (
          <Card
            key={el.key}
            date={el.date}
            title={el.title}
            establishment={el.establishment}
            details={el.details}
            info={el.info}
            skills={el.skills}
            image={el.image}
            links={el.links}
          />
        ))}
      </ul>
    </section>
  );
};

export default Education;
